module.exports = __webpack_public_path__ + "static/media/garb.9cc45791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/garb.jpg
// module id = 186
// module chunks = 0